import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { GameStateService } from '../../../../services/game-state/game-state.service';
import { IGender } from '../../../../interfaces/common-interfaces';
import { MetrikaService } from '../../../../services/metrika.service';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrl: './question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionComponent implements OnDestroy{
  @Output()
  closeModal: EventEmitter<void> = new EventEmitter();

  gender: undefined | IGender = undefined;
  showQuestion = true;

  selectedValue: number;

  constructor(private state: GameStateService, private metrika: MetrikaService) {}

  playClick() {
    this.state.sound.playClickSmallBtn();
  }
  selectValue(val: number) {
    this.playClick();
    this.selectedValue = val;
  }

  apply() {
    const prevVal = localStorage.getItem('questionResult');
    if (!prevVal) {
      this.metrika.reachGoal('understanding_before', {value:this.selectedValue.toString()});
    } else {
      this.metrika.reachGoal('understanding_after', {value:this.selectedValue.toString()});
    }
    localStorage.setItem('questionResult', this.selectedValue.toString());
    this.showQuestion = false;
    this.close();
  }
  close() {
    this.closeModal.emit();
  }

  ngOnDestroy(): void {
    this.state.gamePause = false;
  }
}
